export default "<template>\r\n  <v-input :error-messages=\"['Fatal error']\" error disabled>Input</v-input>\r\n</template>\r\n";